import { render, staticRenderFns } from "./CreateOrUpdateUser.vue?vue&type=template&id=35f47660"
import script from "./CreateOrUpdateUser.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports